module.exports = __webpack_public_path__ + "static/media/quylanmac.350bb2e2.jpeg";